import * as React from 'react';
import { Button, Divider, ListSubheader } from '@mui/material';

export const HeaderMenuItem = ({ link, index, smItems, mdItems, lgItems, onClick }) => {
  const displayStyles = {
    sm: index > smItems - 1 ? 'none' : 'inline-flex',
    md: index > mdItems - 1 ? 'none' : 'inline-flex',
    lg: index > lgItems - 1 ? 'none' : 'inline-flex',
    xl: 'inline-flex'
  };

  const menuItemStyles = {
    mx: 1,
    display: displayStyles
  };

  if (link.separator) {
    return (
      <Divider
        sx={{
          height: 28,
          m: 0.5,
          display: displayStyles,
          verticalAlign: 'middle'
        }}
        orientation="vertical"
      />
    );
  }

  if (!link.path) {
    return <ListSubheader sx={menuItemStyles}>{link.text}</ListSubheader>;
  }

  return (
    <Button
      href={link.path}
      onClick={onClick}
      variant={link.variant ?? 'text'}
      color={link.color ?? 'secondary'}
      sx={menuItemStyles}
    >
      {link.text}
    </Button>
  );
};
